// ============================================================================
// MODULE SWITCHES → MENU (settings cleanup C1/C3)
// ============================================================================
// A module that is off for every property is hidden from the sidebar at sign-in. Role
// permissions are untouched (the server refuses a switched-off module on its own), so turning
// the module back on shows the menus again at the next sign-in. The switches are the Modules
// section of Setup > Settings; the tenant's licence (Tenant Hub feature flags) is the layer above.
//
// Tax and Fairbooks setup screens stay visible while off: masters, mappings and ledger mapping
// are set up BEFORE the module is turned on. Only screens that work on live data are hidden.

import { MODULE_KEYS, type ModuleSwitch } from 'api/types/config.types';

const isRestaurantScreen = (id: string) => id.startsWith('dineops-') || id === 'print-queue';

const HIDDEN_WHEN_OFF: Record<string, (id: string) => boolean> = {
  [MODULE_KEYS.restaurant]: isRestaurantScreen,
  [MODULE_KEYS.fairbooks]: (id) => id === 'posting-register',
};

/**
 * The module ids to show in the sidebar: `visibleModules` minus the screens of modules that are
 * off everywhere. A switch missing from `switches` (an older API) hides nothing.
 */
export function menuModulesForSwitches(
  visibleModules: ReadonlyArray<string>,
  switches: ReadonlyArray<ModuleSwitch>,
): string[] {
  const hide = switches
    .filter((s) => !s.onAnywhere && HIDDEN_WHEN_OFF[s.configKey])
    .map((s) => HIDDEN_WHEN_OFF[s.configKey]);
  return visibleModules.filter((id) => !hide.some((h) => h(id)));
}
